import { getIam, request } from '../utils/request';

// 获取徒刑验证码
export async function luatGetCaptcha() {
  const IAM = getIam();
  return request.post({
    url: `${IAM}luat/user/get_captcha`,
  });
}

// 发送手机验证码
export async function luatGenVcode( data: { captchaId: string; captchaCode: string; phone: string }) {
  const IAM = getIam();

  return request.post({
    url: `${IAM}luat/user/gen_vcode`,
    data: data,
  });
}

// 注册
export async function luatRegisterUser(
  data: {
    name: string;
    phone: string;
    password: string;
    vcode: string;
  },
) {
    const IAM = getIam();

  return request.post({
    url: `${IAM}luat/user/register_user`,
    data: data,
  });
}

// 修改密码
export async function luatResetPassword(
    data: {
      phone: string;
      newPassword: string;
      vcode: string;
    },
){
    const IAM = getIam();
    return request.post({
        url: `${IAM}luat/user/reset_password`,
        data: data,
    });
}
